import React from 'react';
import IrreversibleBlocksTable from '../../../components/Common/IrreversibleBlocksTable';
import './RecentBlocks.css';

const RecentBlocks = ({ globalPropsData = null }) => {

    return (
        <div className="latest-blocks-container">
            <IrreversibleBlocksTable
                showHeader={false}
                blockCount={10}
                className=""
                isLive={true}
                globalPropsData={globalPropsData}
            />
        </div>
    );
};

export default RecentBlocks;